import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { readFile } from "../inventory-item-list/item-list.component.service";
import { getCategories } from "../inventory-item-create/item-create.component.service";
import { PRIMARY_KEY } from "@constants/app.constants";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import { menuUrl } from "../inventory-item-list/model/item-list.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import MESSAGES from "@constants/messages.constants";
import { getInventoryFileUploadInputs } from "@screens/common/inventory-file-upload/inventory-file-upload.modal";
import InventoryFileUploadTemplateComponent from "@screens/common/inventory-file-upload/invntory-file-upload-template";


const {
  ALERT_TYPES: { SUCCESS, ERROR },
  FILE_UPLOAD_ALERT: { FILE_UPLOAD_ALERT },
} = MESSAGES;

const InventoryItemsFileUploadComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");

  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
    loading: true,
  });
  const [formInputs, setFormInputs] = useState([]);

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    if (errors.length > 0) return;
  
    let payload = {};
  
    values.forEach((field) => {
      payload[field.name] = field.value;
    });
  
    // force-pick file from DOM
    const fileInput = document.querySelector('input[name="file"]');
    if (fileInput && fileInput.files.length > 0) {
      payload.file = fileInput.files[0]; 
    }
  
    setFormTriggers({ ...formTriggers, loading: true });

    const response = await readFile(payload);
    console.log({payload});
    

    setFormTriggers({ ...formTriggers, loading: false });

    if (response.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: FILE_UPLOAD_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(setAlertMessage({ type: ERROR, message: response.message }));
    }
  };

  const onLoad = async () => {
    const categoryResponse = await getCategories();

    if (categoryResponse.status) {
      const formattedCategories = categoryResponse.data.map((cat) => ({
        name: cat.name,
        value: cat[PRIMARY_KEY], // usually "id"
      }));

      // pass categories into your input builder
      const formInputData = getInventoryFileUploadInputs(formattedCategories, {});
      setFormInputs(formInputData);
      setFormTriggers({ ...formTriggers, loading: false });
    } else {
      setFormTriggers({ ...formTriggers, loading: false });
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  const templateModal = {
    formTriggers,
    formInputs,
  };

  const templateEvents = {
    handleFormSubmit: handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <InventoryFileUploadTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default InventoryItemsFileUploadComponent;
